/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Showstartbutton2Inputs */

const en_entity_showstartbutton2 = /** @type {(inputs: Entity_Showstartbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Start Button`)
};

const de_entity_showstartbutton2 = /** @type {(inputs: Entity_Showstartbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start-Button anzeigen`)
};

/**
* | output |
* | --- |
* | "Show Start Button" |
*
* @param {Entity_Showstartbutton2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_showstartbutton2 = /** @type {((inputs?: Entity_Showstartbutton2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Showstartbutton2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_showstartbutton2(inputs)
	return de_entity_showstartbutton2(inputs)
});
export { entity_showstartbutton2 as "entity_showStartButton" }